import { render, staticRenderFns } from "./MenuPanelList.vue?vue&type=template&id=d66a80fa&"
import script from "./MenuPanelList.vue?vue&type=script&lang=js&"
export * from "./MenuPanelList.vue?vue&type=script&lang=js&"
import style0 from "./MenuPanelList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports